import React, { MouseEventHandler } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Box, DialogTitle, Typography } from "@mui/material";

type PropsType = {
  handleClose: MouseEventHandler<SVGSVGElement>;
  title: string;
};
export default function ModalBoxHeader(props: PropsType) {
  const { handleClose, title } = props;

  return (
    <>
      <DialogTitle>
        <Box display="flex" justifyContent={"space-between"}>
          <Typography variant="h6">{title}</Typography>
          <CloseIcon color="error" cursor="pointer" onClick={handleClose} />
        </Box>
      </DialogTitle>
    
    </>

    // <Box>
    //   <Box
    //     className="modal-header"
    //     display="flex"
    //     alignItems="center"
    //     justifyContent="space-between"
    //     sx={{ padding: "1rem" }}
    //   >
    //     <Typography
    //       variant={"h6"}
    //       style={{ textAlign: "center" }}
    //     >{`${title}`}</Typography>
    //     <CloseIcon onClick={handleClose} sx={{ cursor: "pointer" }} />
    //   </Box>
    //   <hr />
    // </Box>
  );
}
